<template>
    <v-col align="center" class="">
        <span v-if="!isWaitlistClass">
            <p class="tw-text-lg tw-font-bold">Booking Success!</p>
            <p class="tw-text-base tw-font-normal tw-text-textSecondary">
                {{ $t('message.bookingSuccess') }}
            </p>
        </span>
        <p v-else>
            {{ $t('message.waitlistSuccess') }}
        </p>
        <lottie-animation
            path="lottie/greentick.json"
            :height="200"
            :width="200"
        />
        <GuestsTableV2
            v-if="isGroupOrFamily && classId && !isWaitlistClass"
            :classId="classId"
            :userIds="userIds"
            :subAccounts="subAccounts"
            :bookingType="bookingType"
            :spotNumbers="spotNumbers"
            :hideSpots="hideSpots"
        />
        <v-btn
            v-if="packageItem.isPackageShareable && !isBookClass"
            color="primary"
            width="40%"
            depressed
            @click="openDialog"
            >{{ $t('message.sharePackage') }}</v-btn
        >

        <v-dialog v-model="dialog" width="600px">
            <v-card>
                <v-card-title>
                    <v-col class="pb-0">
                        <v-row class="justify-end">
                            <v-icon @click="closeDialog">mdi-close</v-icon>
                        </v-row>
                    </v-col>
                </v-card-title>
                <v-card-text>
                    <PackageShareWithCard
                        :packageItem="this.packageItem"
                        @shareAfterPurchase="getPackageItem"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-btn
            @click="onDone"
            color="success"
            class="tw-mt-4 tw-w-full !tw-uppercase"
        >
            {{ $t('message.done') }}
        </v-btn>
    </v-col>
</template>
<script>
import { SHARE_PACKAGE } from '@/analytics/events'
import PackageShareWithCard from '@/components/packages/PackageShareWithCard'
import { getSharedMembers } from '../../util/packages/getSharedMembers'
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue' // import lottie-vuejs
import GuestsTableV2 from '../../modules/parentchild/GuestsTableV2.vue'

export default {
    props: {
        packageId: String,
        isBookClass: {
            default: false,
            type: Boolean,
        },
        isWaitlistClass: {
            default: false,
            type: Boolean,
        },
        classId: String,
        bookingType: String,
        userIds: Array,
        subAccounts: Array,
        spotNumbers: Array,
        hideSpots: Boolean,
    },
    computed: {
        isGroupOrFamily() {
            return this.bookingType === 'group' || this.bookingType === 'family'
        },
    },
    components: {
        PackageShareWithCard,
        LottieAnimation,
        GuestsTableV2,
    },
    data() {
        return {
            dialog: false,
            users: [],
            packageItem: Object,
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false
        },
        openDialog() {
            this.$gtag.event(SHARE_PACKAGE)
            this.dialog = true
        },
        async getPackageItem() {
            this.users = await getSharedMembers(this.packageId)
            this.packageItem = { ...this.users[0], id: this.packageId }
        },
        onDone() {
            this.$emit('done')
        },
    },
    async created() {
        this.getPackageItem()
    },
}
</script>
